import type {
  LabelsColumnBinding,
  LabelsExplorerTabSource,
} from 'components/Table/model/ExplorerTableCellContext';
import { isObject } from 'utils/object/isObject';

export const readTableRowString = (
  row: unknown,
  key: string,
): string | null => {
  if (!isObject(row)) {
    return null;
  }
  const value = row[key];
  return typeof value === 'string' && value.length > 0 ? value : null;
};

export const getLabelsExplorerSources = (
  row: unknown,
  columns: LabelsColumnBinding[] = [],
): LabelsExplorerTabSource[] =>
  columns.flatMap((column) => {
    const targetId = readTableRowString(row, column.targetIdField);
    return targetId === null
      ? []
      : [
          {
            columnKey: column.columnKey,
            kind: 'labels',
            targetId,
            targetType: column.targetType,
            title: column.title,
          },
        ];
  });
